import { baseAxios } from "./apiDefault";
import promiseHandler from "@/utils/promise";

export const infoHeader = async () =>
  promiseHandler(baseAxios().get("user/api/v1.0/profile/basic"));
